// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDGndAyQSPtNToFqNBFxZfbOdxDFPn8aX0",
  authDomain: "ddsurvey-97713.firebaseapp.com",
  projectId: "ddsurvey-97713",
  storageBucket: "ddsurvey-97713.appspot.com",
  messagingSenderId: "1002032966810",
  appId: "1:1002032966810:web:263aac88fbe3da5c310323",
  measurementId: "G-305BEWNJBK",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export { app };
